import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router'
import styled, { ThemeProvider } from 'styled-components'
import { SnackbarProvider, MaterialDesignContent } from 'notistack'
import { IS_INTEGRATED_VERSION } from './config/ConfigManager'
import { defaultTheme } from './theme'
import { BaseProvider } from './config/analytics/core'
import { analyticsInit } from './config/analytics/init'
import { TrackingProvider } from './config/analytics/tracking'
import router from './helpers/history'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

const StyledInfoNotification = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-info': {
    backgroundColor: '#EBEBEB',
    color: '#000000',
  },
}))

function App(): ReactElement {
  const muiTheme = createTheme()

  const [analyticsProviders, setAnalyticsProviders] = useState<BaseProvider[]>(
    []
  )

  useEffect(() => {
    analyticsInit.init()
    setAnalyticsProviders(analyticsInit.getProviders())
  }, [])

  return (
    <Wrapper>
      <Content>
        <TrackingProvider providers={analyticsProviders}>
          <MuiThemeProvider theme={muiTheme}>
            <ThemeProvider theme={defaultTheme}>
              <QueryClientProvider client={queryClient}>
                <SnackbarProvider
                  classes={{
                    root: 'notification-wrapper',
                  }}
                  Components={{
                    info: StyledInfoNotification,
                  }}
                >
                  <RouterProvider router={router} />
                </SnackbarProvider>
              </QueryClientProvider>
            </ThemeProvider>
          </MuiThemeProvider>
        </TrackingProvider>

        {/* Form used to transfer data to host integrations when `useDataIsland` is enabled. */}
        {IS_INTEGRATED_VERSION && (
          <form id="partsBasketForm">
            <input type="hidden" id="partsBasket" name="partsBasket" value="" />
          </form>
        )}
      </Content>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

const Content = styled.div`
  width: 100%;
  max-width: 1920px;
`

export default App
